// CacheKey 59cf886370be7db13e1a9eabd46877f1
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-SUFFOLK_CARE_COLLABORATIVE": {
    data_view: {
      default_name: {
        patients_search: "Participants Search"
      },
      headers: {
        defaults: {
          encounter: {
            arrival_date: "Survey Date",
            encounter_id: "Unique Insignia ID"
          },
          interaction: {
            unit_name: "Participant List"
          },
          unit: {
            name: "Participant List",
            facility: "Agency"
          }
        },
        workflows_view: {
          patient: {
            name: "Participant",
            id: "Participant ID"
          }
        }
      }
    }
  }
}

